import React from 'react';

import GroupingModal from './GroupingModal';

import commonConfigs from "../../../commonConfig.json";

let modalConfigs = commonConfigs.modalProps;

const CustomModal = props => {
    if(props.type === modalConfigs.modalType.FILTER_SEC_GROUPING){
        return (
            <GroupingModal {...props}></GroupingModal>
        );
    }
}
export default React.memo(CustomModal);